import { resetForm } from "./resetForm";

//
// $("[for=\"other\"]").on("click", function () {
//     resetForm($form);
//     // .prop("checked", false)
//     // .prop("selected", false);
//     $submit.prop("disabled", true);
//     $submit.addClass("btn--disabled");
// });
//
// $("[for=\"home\"]").on("click", function () {
//     // reset form to original fields
//     document.querySelector(".questionsForm").reset();
//     $submit.prop("disabled", false);
//     $submit.removeClass("btn--disabled");
// });

// TODO: TE - broaden scope of this to work with other partner journeys
// Membership form question - when clicking on 'no', remove the membership number
$('[for="no"]').on("click", function () {
  // reset form to original fields
  $("#membershipNumber_orv").val(" ");
});
